<!--  -->
<template>
  <div :class="['drawResultBox', { inApp: $root.$data.isApp }]">
    <common-title
      titleName="创意物料"
      :bcColor="'#fff'"
      :zIndex="1000"
    >
    </common-title>
    <section class="drawReaultCenter">
      <img
        class="photo"
        :src="photoUrl"
        alt=""
      >
    </section>
    <div class="saveBottom">
      <div
        class="save-btn"
        @click="toSave"
      >保存图片</div>
      <button
        class="share-btn"
        @click="toShare"
      >分享给好友</button>
    </div>
    <ShareDraw v-if="showShare" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShareDraw from './shareDraw.vue';

export default {
  components: {
    ShareDraw,
  },
  data() {
    return {
      showShare: false,
      loading: true,
      photoUrl: '',
      appUrl: '', // 保存图片传给App base64格式的
      list: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(1).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(2).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(3).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(4).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(5).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(6).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%9F%A9%E5%BD%A2%402x%20(7).png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 取对应图片
    getRoundNum() {
      const { drawNum } = this.$route.query;
      this.photoUrl = this.list[Number(drawNum)];
    },
    // 保存
    toSave() {
      if (this.$root.isApp) {
        this.$sendToApp(
          'savePic',
          {
            pic: this.photoUrl,
          },
          false,
        );
      } else {
        this.$toast('请长按上方图片保存');
      }
    },
    // 分享
    toShare() {
      this.showShare = true;
    },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
  },
  created() {
    this.getRoundNum();
    this.change();
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.drawResultBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 100px;
  background: #f9f9fa;

  &.inApp {
    padding-top: 0;
  }
  .drawReaultCenter {
    position: relative;
    width: 100%;
    padding-bottom: 140px;
    text-align: center;
    .photo {
      width: 90%;
      height: 100%;
      background-size: cover;
    }
    .code {
      position: absolute;
      top: 1018px;
      left: 502px;
      width: 140px;
      height: 140px;
    }
  }
  .saveBottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 50px;
    background: #fff;
    .save-btn {
      box-sizing: border-box;
      width: 321px;
      height: 75px;
      color: #ff7f41;
      font-weight: 400;
      font-size: 30px;
      line-height: 75px;
      text-align: center;
      background: #fff;
      border: 1px solid #ff7f41;
      border-radius: 43px;
    }
    .share-btn {
      width: 321px;
      height: 75px;
      color: #fff;
      font-weight: 400;
      font-size: 30px;
      line-height: 75px;
      text-align: center;
      background: #ff7f41;
      border-radius: 43px;
    }
  }
}
</style>
